import { render, staticRenderFns } from "./ComponentLoadingError.vue?vue&type=template&id=6720d2e1&"
import script from "./ComponentLoadingError.vue?vue&type=script&lang=js&"
export * from "./ComponentLoadingError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports